import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import React, { Suspense } from "react";

const LazyAnalytics = React.lazy(() =>
  import("@vercel/analytics/react").then((mod) => ({
    default: mod.Analytics,
  })),
);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <Suspense fallback={null}>
      {typeof window !== "undefined" && <LazyAnalytics />}
    </Suspense>
  </React.StrictMode>,
);
